export default {
  PERSONALCENTER_ADDRESS_SMAIL: {
    key: 'personalcenter_address_smail',
    label: '个人中心-地址管理-【寄件地址】'
  },
  FAVORITE_ADDRESS_SMAIL: {
    key: 'favorite_address_smail',
    label: '收藏夹-地址管理-【寄件地址】'
  },
  QUICKENTRY_ADDERSS_SMAIL: {
    key: 'quickentry_adderss_smail',
    label: '快捷入口-地址管理-【寄件地址】'
  },
  MENU_QUERY_ADDRESS_SMAIL: {
    key: 'menu_query_address_smail',
    label: '菜单查询-地址管理-【寄件地址】'
  },
  ADDRESS_SMAIL_ADD: {
    key: 'address_smail_add',
    label: '地址管理-寄件地址-【新增地址】'
  },
  ADDRESS_SMAIL_BATCHADD: {
    key: 'address_smail_batchadd',
    label: '地址管理-寄件地址-【批量新增】'
  },
  ADDRESS_SMAIL_BATCHDEL: {
    key: 'address_smail_batchdel',
    label: '地址管理-寄件地址-【批量删除】'
  },
  ADDRESS_SMAIL_BATCHEXPORT: {
    key: 'address_smail_batchexport',
    label: '地址管理-寄件地址-【批量导出】'
  },
  ADDRESS_SMAIL_SEE: {
    key: 'address_smail_see',
    label: '地址管理-寄件地址-【隐藏小眼睛】'
  },
  ADDRESS_SMAIL_ONEPAGE: {
    key: 'address_smail_onepage',
    label: '地址管理-寄件地址-【当页全选】'
  },
  ADDRESS_SMAIL_ALLPAGE: {
    key: 'address_smail_allpage',
    label: '地址管理-寄件地址-【全部全选】'
  },
  ADDRESS_SMAIL_NUMBERPAGE: {
    key: 'address_smail_numberpage',
    label: '地址管理-寄件地址'
  },
  ADDRESS_SMAIL_ADD_DEFAULT: {
    key: 'address_smail_add_default',
    label: '地址管理-寄件地址-新增地址-【设为默认地址】'
  },
  ADDRESS_SMAIL_ADD_PUBLIC: {
    key: 'address_smail_add_public',
    label: '地址管理-寄件地址-新增地址-【设为公共地址】'
  },
  ADDRESS_SMAIL_BATCHADD_FAIL: {
    key: 'address_smail_batchadd_fail',
    label: '地址管理-寄件地址-批量新增-【导出失败明细】'
  },
  ADDRESS_SMAIL_BATCHADD_MODIFY: {
    key: 'address_smail_batchadd_modify',
    label: '地址管理-寄件地址-批量新增-【修改失败信息】'
  },
  ADDRESS_SMAIL_BATCHADD_SELDEL: {
    key: 'address_smail_batchadd_seldel',
    label: '地址管理-寄件地址-批量新增-【选择需要修改的地址】'
  },
  ADDRESS_SMAIL_BATCHADD_SELDEL_CANCEL: {
    key: 'address_smail_batchadd_seldel_cancel',
    label: '地址管理-寄件地址-批量新增-选择需要修改的地址-【取消】'
  },
  ADDRESS_SMAIL_BATCHADD_SELDEL_DEL: {
    key: 'address_smail_batchadd_seldel_del',
    label: '地址管理-寄件地址-批量新增-选择需要修改的地址-【删除】'
  },
  ADDRESS_SMAIL_BATCHADD_EXPFAIL: {
    key: 'address_smail_batchadd_expfail',
    label: '地址管理-寄件地址-批量新增-【导出失败列表】'
  },
  ADDRESS_SMAIL_BATCHADD_SAVE: {
    key: 'address_smail_batchadd_save',
    label: '地址管理-寄件地址-批量新增-【保存】'
  },
  ADDRESS_SMAIL_BATCHADD_SAVEXPORT: {
    key: 'address_smail_batchadd_savexport',
    label: '地址管理-寄件地址-批量新增-【保存并导入】'
  },
  PERSONALCENTER_ADDRESS_RECEIPT: {
    key: 'personalcenter_address_receipt',
    label: '个人中心-地址管理-【收件地址】'
  },
  FAVORITE_ADDRESS_RECEIPT: {
    key: 'favorite_address_receipt',
    label: '收藏夹-地址管理-【收件地址】'
  },
  QUICKENTRY_ADDERSS_RECEIPT: {
    key: 'quickentry_adderss_receipt',
    label: '快捷入口-地址管理-【收件地址】'
  },
  MENUQUERY_ADDRESS_RECEIPT: {
    key: 'menuquery_address_receipt',
    label: '菜单查询-地址管理-【收件地址】'
  },
  ADDRESS_RECEIPT_ADD: {
    key: 'address_receipt_add',
    label: '地址管理-收件地址-【新增地址】'
  },
  ADDRESS_RECEIPT_BATCHADD: {
    key: 'address_receipt_batchadd',
    label: '地址管理-收件地址-【批量新增】'
  },
  ADDRESS_RECEIPT_BATCHDEL: {
    key: 'address_receipt_batchdel',
    label: '地址管理-收件地址-【批量删除】'
  },
  ADDRESS_RECEIPT_BATCHEXPORT: {
    key: 'address_receipt_batchexport',
    label: '地址管理-收件地址-【批量导出】'
  },
  ADDRESS_RECEIPT_SEE: {
    key: 'address_receipt_see',
    label: '地址管理-收件地址-【隐藏小眼睛】'
  },
  ADDRESS_RECEIPT_ONEPAGE: {
    key: 'address_receipt_onepage',
    label: '地址管理-收件地址-【当页全选】'
  },
  ADDRESS_RECEIPT_ALLPAGE: {
    key: 'address_receipt_allpage',
    label: '地址管理-收件地址-【全部全选】'
  },
  ADDRESS_RECEIPT_NUMBERPAGE: {
    key: 'address_receipt_numberpage',
    label: '地址管理-收件地址'
  },
  ADDRESS_RECEIPT_ADD_DEFAULT: {
    key: 'address_receipt_add_default',
    label: '地址管理-收件地址-【设为默认地址】'
  },
  ADDRESS_RECEIPT_ADD_PUBLIC: {
    key: 'address_receipt_add_public',
    label: '地址管理-收件地址-新增地址-【设为公共地址】'
  },
  ADDRESS_RECEIPT_BATCHADD_FAIL: {
    key: 'address_receipt_batchadd_fail',
    label: '地址管理-收件地址-批量新增-【导出失败明细】'
  },
  ADDRESS_RECEIPT_BATCHADD_MODIFY: {
    key: 'address_receipt_batchadd_modify',
    label: '地址管理-收件地址-批量新增-【修改失败信息】'
  },
  ADDRESS_RECEIPT_BATCHADD_SELDEL: {
    key: 'address_receipt_batchadd_seldel',
    label: '地址管理-收件地址-批量新增-【选择需要修改的地址】'
  },
  ADDRESS_RECEIPT_BATCHADD_SELDEL_CANCEL: {
    key: 'address_receipt_batchadd_seldel_cancel',
    label: '地址管理-收件地址-批量新增-选择需要修改的地址-【取消】'
  },
  ADDRESS_RECEIPT_BATCHADD_SELDEL_DEL: {
    key: 'address_receipt_batchadd_seldel_del',
    label: '地址管理-收件地址-批量新增-选择需要修改的地址-【删除】'
  },
  ADDRESS_RECEIPT_BATCHADD_EXPFAIL: {
    key: 'address_receipt_batchadd_expfail',
    label: '地址管理-收件地址-批量新增-【导出失败列表】'
  },
  ADDRESS_RECEIPT_BATCHADD_SAVE: {
    key: 'address_receipt_batchadd_save',
    label: '地址管理-收件地址-批量新增-【保存】'
  },
  ADDRESS_RECEIPT_BATCHADD_SAVEXPORT: {
    key: 'address_receipt_batchadd_savexport',
    label: '地址管理-收件地址-批量新增-【保存并导入】'
  },
  PERSONALCENTER_ADDRESS_RETURNGOODS: {
    key: 'personalcenter_address_returngoods',
    label: '个人中心-地址管理-【退货地址】'
  },
  FAVORITE_ADDRESS_RETURNGOODS: {
    key: 'favorite_address_returngoods',
    label: '收藏夹-地址管理-【退货地址】'
  },
  QUICKENTRY_ADDERSS_RETURNGOODS: {
    key: 'quickentry_adderss_returngoods',
    label: '快捷入口-地址管理-【退货地址】'
  },
  MENU_QUERY_ADDRESS_RETURNGOODS: {
    key: 'menu_query_address_returngoods',
    label: '菜单查询-地址管理-【退货地址】'
  },
  ADDRESS_RETURNGOODS_ONEPLACEMODIFY: {
    key: 'address_returngoods_oneplacemodify',
    label: '地址管理-退货地址-统一退一地【修改】'
  },
  ADDRESS_RETURNGOODS_ONEPLACEDEL: {
    key: 'address_returngoods_oneplacedel',
    label: '地址管理-退货地址-统一退一地【删除】'
  },
  ADDRESS_RETURNGOODS_DELIVERYMODIFY: {
    key: 'address_returngoods_deliverymodify',
    label: '地址管理-退货地址-退发货地【修改】'
  },
  ADDRESS_RETURNGOODS_DELIVERYDEL: {
    key: 'address_returngoods_deliverydel',
    label: '地址管理-退货地址-退发货地【删除】'
  },
  ADDRESS_RETURNGOODS_NEARBYMODIFY: {
    key: 'address_returngoods_nearbymodify',
    label: '地址管理-退货地址-就近退【修改】'
  },
  ADDRESS_RETURNGOODS_MULTIDELIVERYMODIFY: {
    key: 'address_returngoods_multideliverymodify',
    label: '地址管理-退货地址-发货仓对应【修改】'
  },
  ADDRESS_RETURNGOODS_NEARBY_SET: {
    key: 'address_returngoods_nearby_set',
    label: '地址管理-退货地址-就近退-【设置就近退地址】'
  },
  ADDRESS_RETURNGOODS_NEARBY_MODIFY: {
    key: 'address_returngoods_nearby_modify',
    label: '地址管理-退货地址-就近退-【修改】'
  },
  ADDRESS_RETURNGOODS_NEARBY_DEL: {
    key: 'address_returngoods_nearby_del',
    label: '地址管理-退货地址-就近退-【删除】'
  },
  ADDRESS_RETURNGOODS_NEARBY_SEE: {
    key: 'address_returngoods_nearby_see',
    label: '地址管理-退货地址-就近退-【隐藏小眼睛】'
  },
  ADDRESS_RETURNGOODS_NEARBY_BATCHDEL: {
    key: 'address_returngoods_nearby_batchdel',
    label: '地址管理-退货地址-就近退-【批量删除】'
  },
  ADDRESS_RETURNGOODS_MULTIDELIVERY_BATCHDEL: {
    key: 'address_returngoods_multidelivery_batchdel',
    label: '地址管理-退货地址-发货仓对应-【批量删除】'
  },
  ADDRESS_RETURNGOODS_MULTIDELIVERY_ADD: {
    key: 'address_returngoods_multidelivery_add',
    label: '地址管理-退货地址-发货仓对应-【新增】'
  },
  ADDRESS_RETURNGOODS_MULTIDELIVERY_MODIFY: {
    key: 'address_returngoods_multidelivery_modify',
    label: '地址管理-退货地址-发货仓对应-【修改】'
  },
  ADDRESS_RETURNGOODS_MULTIDELIVERY_DEL: {
    key: 'address_returngoods_multidelivery_del',
    label: '地址管理-退货地址-发货仓对应-【删除】'
  },
  ADDRESS_RETURNGOODS_MULTIDELIVERY_SEE: {
    key: 'address_returngoods_multidelivery_see',
    label: '地址管理-退货地址-发货仓对应-【隐藏小眼睛】'
  },
  ADDRESS_RETURNGOODS_MULTIDELIVERY_ONEPAGE: {
    key: 'address_returngoods_multidelivery_onepage',
    label: '地址管理-退货地址-发货仓对应-【当页全选】'
  },
  ADDRESS_RETURNGOODS_MULTIDELIVERY_ALLPAGE: {
    key: 'address_returngoods_multidelivery_allpage',
    label: '地址管理-退货地址-发货仓对应-【全部全选】'
  },
  ADDRESS_RETURNGOODS_MULTIDELIVERY_NUMBERPAGE: {
    key: 'address_returngoods_multidelivery_numberpage',
    label: '地址管理-退货地址-发货仓对应'
  }

}
